import dayjs from "dayjs";
  import utc from 'dayjs/plugin/utc';
  import customParseFormat from "dayjs/plugin/customParseFormat"
  import { Box, Autocomplete } from "@mui/material"
  import { StyledOutlinedTextField } from "../../../Infrastructure/Theme/styledComponents";
  
  dayjs.extend(utc);
  dayjs.extend(customParseFormat)


  export const TimePickerDropdown = ({ label, value, onChange, disabled, width }) => {
    const generateTimeOptions = () => {
      const times = [];
      const startTime = dayjs().hour(8).minute(0)
      const endTime = startTime.add(24, "hour")
      const interval = 15
      let currentTime = startTime
      while (currentTime.isBefore(endTime)) {
        times.push(currentTime.format("h:mm A"))
        currentTime = currentTime.add(interval, "minute")
      }
      return times
    };
    const timeOptions = generateTimeOptions()
    const selectedTimeStr = value ? value.format("h:mm A") : ""

    const handleChange = (event, newValue) => {
      if (newValue) {
        const selectedTime = dayjs(newValue, "h:mm A")
        onChange(selectedTime)
      } else {
        onChange(null)
      }
    }
    const preventOpenWhenDisabled = (e) => {
      if (disabled) {
        e.preventDefault();
        e.stopPropagation();
      }
    };
    return (
      <Box sx={{ width: { xs: "100%", sm: width } }}>
        <Autocomplete
          options={timeOptions}
          value={selectedTimeStr || null}
          onChange={handleChange}
          disabled={disabled}
          open={disabled ? false : undefined}
          onOpen={(e) => { if (disabled) e.preventDefault(); }}
          onFocus={preventOpenWhenDisabled}
          onMouseDown={preventOpenWhenDisabled}
          onKeyDown={(e) => { if (disabled) e.preventDefault(); }}
          renderInput={(params) => (
            <StyledOutlinedTextField
              {...params}
              label={label}
              variant="outlined"
              disabled={disabled}
              inputProps={{
                ...params.inputProps,
                readOnly: !!disabled
              }}
            />
          )}  
          fullWidth
          disableClearable
          isOptionEqualToValue={(option, val) => option === val}
           sx={{
              cursor: disabled ? "default" : "pointer",
              border: 'none', mt: "6px",
              "& .css-1q60rmi-MuiAutocomplete-endAdornment": {
                top: "auto !important",
              }
            }}
        />
        </Box>
    );
  };